module.exports = __webpack_public_path__ + "static/media/1004757.4b7175ce.png";